import { render, staticRenderFns } from "./NicheBasedSiteListView.vue?vue&type=template&id=008848a7&"
import script from "./NicheBasedSiteListView.vue?vue&type=script&lang=js&"
export * from "./NicheBasedSiteListView.vue?vue&type=script&lang=js&"
import style0 from "./NicheBasedSiteListView.vue?vue&type=style&index=0&id=008848a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports